export const namespaced = true

export const state = {
  filterParams: {
    targetGroup: null,
    timeValue: null,
    topic: null,
  }
}

export const mutations = {
  SET(state, filterParams) {
    state.filterParams = filterParams
  }
}
export const actions = {
  set({ commit }, filterParams) {
    commit('SET', filterParams)
  }
}

export const getters = {
  getResults(state, getters, rootState) {
    let playlists = rootState.scenarioModule.playlists

    // Just filtering the topic for now
    return playlists.filter(pl => {
      return (pl.tags && pl.tags.includes(state.filterParams.topic) && pl.duration <= state.filterParams.timeValue * 60)
    })
  }
}